import { OktaAuth } from "@okta/okta-auth-js";
import { ConfigSettings } from "../config/Config";
import { init } from "./HttpService";

const settings = ConfigSettings();
const oktaAuth = new OktaAuth(settings.oidc);

const resquestToken = async (companyId) => {
  let token = oktaAuth.getAccessToken();
  let url = `${settings.resourceServer.apiUrl}userAccess/UserAccessAuth`;
  if (companyId)
    url = `${settings.resourceServer.apiUrl}userAccess/UserAccessAuth/${companyId}`;

  if (!token) {
    await oktaAuth.signInWithRedirect("/dashboard");
  } else {
    return init(url, token).then((res) => {
      localStorage.setItem("@vitae/internal_token", res.token);
      localStorage.setItem("@vitae/user", JSON.stringify(res));
      document.getElementById("current_company_id").value =
        res.companyAbbreviation;
      return res;
    });
  }
};
export const authService = {
  logout: function () {
    localStorage.clear();
  },
  login: function () {
    return resquestToken();
  },
  changeCompany(companyId) {
    return resquestToken(companyId);
  },
  refresh: function () {
    return oktaAuth.signInWithRedirect("/dashboard");
  },

  getToken: function () {
    return localStorage.getItem("@vitae/internal_token");
  }
};
